import { render, staticRenderFns } from "./BasicNoticeDetail.vue?vue&type=template&id=6f304989&scoped=true"
import script from "./BasicNoticeDetail.vue?vue&type=script&lang=js"
export * from "./BasicNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./BasicNoticeDetail.vue?vue&type=style&index=0&id=6f304989&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f304989",
  null
  
)

export default component.exports